module.exports = __webpack_public_path__ + "prizes-bg.4aad3386.png";